import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { DisclaimerBanner } from "@/components/DisclaimerBanner";
import { useLang } from "@/contexts/LanguageContext";

export default function GovInclusion() {
  const [s, setS] = useState({});
  const { t } = useLang();
  useEffect(() => { api.get("/reports/government-summary").then((r) => setS(r.data)).catch(() => {}); }, []);
  const items = [
    ["g_msmes", s.registered_msmes],
    ["g_ready", s.credit_ready_msmes],
    ["g_women", s.women_owned_cases],
    ["g_cfree", s.collateral_free_cases],
    ["g_total_sanct", s.total_sanctioned],
    ["g_total_disb", s.total_disbursed],
    ["g_districts", s.districts_covered],
  ];
  return (
    <div className="space-y-6" data-testid="gov-inclusion">
      <div><h1 className="text-3xl font-bold text-slate-900 brand-heading">{t("inclusion_metrics")}</h1></div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map(([l, v]) => (
          <div key={l} className="p-6 rounded-lg border border-slate-200 bg-white" data-testid={`incl-${l}`}>
            <div className="text-xs uppercase tracking-widest text-slate-500">{t(l)}</div>
            <div className="mt-2 text-3xl font-bold text-slate-900 brand-heading">{v ?? "—"}</div>
          </div>
        ))}
      </div>
      <DisclaimerBanner compact />
    </div>
  );
}
